import { idbClearAll } from "@/utils/idbImages";

/*
  存在這台裝置、但屬於某個帳號的資料：登出、換帳號時要清掉，不能留給下一個人（2026-10-30）。

  升級表單（components/Upgrade/Form1、Form2）會把填到一半的內容存起來，下次打開接著填：
  文字在 localStorage 的 upgrade-form1 / upgrade-form2（審核退回時是 upgrade-form1:<申請 id>），
  證件照在 IndexedDB（utils/idbImages.js）。這些 key 沒有分帳號 —— 換人登入後打開升級表單，
  會看到上一個帳號填的身分證字號、銀行帳號、證件照。

  兩個時機清：
    - 使用者自己登出（store 的 SignOut、切換帳號）
    - 認出現在登入的是「跟上次不同的帳號」（store 的 SyncFullProfile）—— 被登出、換人登入這類
      沒經過登出按鈕的情況。同一個帳號重新登入不清，草稿還在
*/

const DRAFT_KEY_PREFIX = "upgrade-form";
const LAST_ACCOUNT_KEY = "_lastAccountGuid";

/** 清掉升級表單的草稿（文字與證件照） */
export function clearAccountDrafts() {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(DRAFT_KEY_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    /* 無痕模式之類讀不到就算了 */
  }
  idbClearAll().catch(() => {});
}

/** 認出目前登入的帳號時呼叫：跟這台裝置上次登入的帳號不同，先清掉上一個帳號的草稿 */
export function noteSignedInAccount(accountGuid) {
  if (!accountGuid) return;
  try {
    const last = localStorage.getItem(LAST_ACCOUNT_KEY);
    if (last && last !== accountGuid) clearAccountDrafts();
    localStorage.setItem(LAST_ACCOUNT_KEY, accountGuid);
  } catch (e) {
    /* 略過 */
  }
}
